// extracted by mini-css-extract-plugin
export default {"fluid-container":"_1l2vben","fluidContainer":"_1l2vben","fluid-container-wide":"_1r07p0h","fluidContainerWide":"_1r07p0h"};